import { Image } from '@ccg/core';
import React$1 from 'react';
import { objectSpread2 as _objectSpread2 } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import PropTypes$1 from 'prop-types';
import StyledOverview from './Overview.style.js';

const splitArray = arr => {
  const array1 = arr.map((item, index) => _objectSpread2({
    loopIndex: index
  }, item));
  const array2 = array1.splice(0, Math.ceil(array1.length / 2));
  return [array2, array1];
};

const Overview = ({
  images,
  currentIndex,
  handleChange
}) => {
  const splittedArray = splitArray(images);
  return /*#__PURE__*/React$1.createElement(StyledOverview, null, /*#__PURE__*/React$1.createElement("div", {
    className: "overview__images"
  }, splittedArray.map((items, i) => /*#__PURE__*/React$1.createElement("div", {
    className: "overview__row",
    key: i
  }, items.map(item => /*#__PURE__*/React$1.createElement("div", {
    key: item.id,
    className: "overview__image"
  }, /*#__PURE__*/React$1.createElement("button", {
    type: "button",
    onClick: () => handleChange(item.loopIndex),
    "aria-current": currentIndex === item.loopIndex,
    className: "overview__image-trigger"
  }, /*#__PURE__*/React$1.createElement(Image, {
    src: item.src,
    lazy: true
  }))))))));
};

Overview.propTypes = {
  images: PropTypes$1.arrayOf(PropTypes$1.shape()).isRequired,
  currentIndex: PropTypes$1.number.isRequired,
  handleChange: PropTypes$1.func.isRequired
};
Overview.defaultProps = {};

export default Overview;
